
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { Form } from './formclienteResetAccount';

export const ClienteResetAccountPage = () => {
    return (
    <ClienteFormState>
        <br />
        <Form title="Actualizar Cuenta" />
    </ClienteFormState>
  );
};
